import React from "react";
import { MerckLabel } from "../../types/merckLabel";
import { getMerckLabels, getMerckLocations } from "../../aplApi/merckLabelHelper";
import FormInputText from "../common/FormInputText";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { MerckLocation } from "../../types/merckLocation";
import { Printer } from "../../types/printer";
import { getPrintersOfflineBySiteId } from "../../aplApi/printersHelper";
import { merckDefaultColumns } from "./MerckDefaultColumns";
import _ from "lodash";
import { DtGridPropsOptions2 } from "../../types/dtGridPropsOptions2";
import { DtGrid2 } from "../common/DtGrid2";
import { printMerck } from "../../aplApi/printHelper";
import { PrintHistoryRequest } from "../../types/printHistoryRequest";
import { translateString } from "../../translations/gridTranslationHelper";
import { combinePdf } from "../../aplApi/pdfHelper";
import DownloadButtonRaw from "../common/Modals/DownloadButtonRaw";

export default function MerckDefault() {
    const aplSettings = AplSettingsSelector();

    const [delieryNote, setDeliveryNote] = React.useState<string>("");
    const [merckLabels, setMerckLabels] = React.useState<MerckLabel[]>([]);
    const [printers, setPrinters] = React.useState<Printer[]>([]);
    const [selectedPrinterId, setSelectedPrinterId] = React.useState<number>(0);
    const [dropLocations, setDropLocations] = React.useState<MerckLocation[]>([]);
    const [dropLocationId, setDropLocationId] = React.useState<number>(0);
    const [page, setPage] = React.useState<number>(1);
    const cancelRef = React.useRef(false);
    const [counterState, setCounterState] = React.useState<number>(0);
    const [pdfFile, setPdfFile] = React.useState<string>("");

    var cancelPrinting = () => {
        cancelRef.current = true;
    };

    const dtGridPropsMerck: DtGridPropsOptions2 = {
        data: merckLabels,
        columnData: merckDefaultColumns(),
        loading: aplSettings.activity.actConsLoading,
        tableName: "merckPallets",
        paging: false,
        showSpinner: aplSettings.activity.actConsLoading && (aplSettings.activity.actCons ?? []).length === 0,
        defaultSort: {
            field: ["sscc"],
            direction: ["asc"]
        },
        selectType: "none",
        colouring: false,
        headerFilters: false,
        setSelectedItems: _.noop,
        tableClass: "table-merckPalletId",
        rowId: "merckPalletId",
        pageLength: 1000,
        selectedItems: [],
        filters: {},
        setFilters: _.noop,
        page: page,
        setPage: setPage
    };

    const deliveryNoteInputField = {
        name: "txt-deliery-note",
        value: delieryNote,
        readOnly: false,
        required: true,
        onChange: setDeliveryNote,
        className: "form-control",
        placeholder: translateString("deliveryNoteMerck", aplSettings.culture),
        autoCompleteOff: false
    };

    const getMerckLabelsFromApi = async () => {
        if (delieryNote === "") return [];
        setPdfFile("");
        getMerckLabels({
            siteId: aplSettings.siteId,
            dropLocationId: dropLocationId === 0 && dropLocations.length > 0 ? dropLocations[0].dropLocationId : dropLocationId,
            deliveryNote: delieryNote
        }).then(response => {
            setMerckLabels(response.data);
        });
    };

    const printMerckLabels = async () => {
        cancelRef.current = false;
        setCounterState(1);
        let results: PrintHistoryRequest[] = [];

        try {
            for (let i = 0; i < merckLabels.length; i++) {
                setCounterState(i + 1);
                if (cancelRef.current) {
                    console.log(`${new Date().toISOString()} loop has terminated`);
                    setCounterState(0);
                    break;
                }
                let printerId = selectedPrinterId === 0 && printers.length > 0 ? printers[0].printerId : selectedPrinterId;
                let result = await printMerck(merckLabels[i], printerId);
                results.push(result.data[0]);
            }
            setCounterState(0);
        } catch (ex: any) {
            setCounterState(0);
        } finally {
            setCounterState(0);
            combinePdf(results)
                .then(response => {
                    setPdfFile(response.data);
                })
                .catch(error => {
                    console.log(error);
                    setPdfFile("");
                });
        }
    };

    React.useEffect(() => {
        getMerckLocations().then(response => {
            setDropLocations(response.data);
        });

        getPrintersOfflineBySiteId(aplSettings.siteId).then(response => {
            setPrinters(response.data);
        });

        return () => {
            setDropLocations([]);
            setDropLocationId(0);

            setPrinters([]);
            setSelectedPrinterId(0);
        };
    }, [aplSettings.siteId]);

    return (
        <div>
            {/* <h1>Merck Default</h1> */}

            <div className="row">
                <div className="col-6">{translateString("deliveryNoteMerck", aplSettings.culture)}</div>
                <div className="col-6">
                    <div className="input-group mb-3">
                        <FormInputText {...deliveryNoteInputField} />
                        <div className="input-group-append">
                            <button
                                id="btn-delvery-search"
                                className="btn btn-sm btn-primary"
                                type="button"
                                onClick={getMerckLabelsFromApi}
                            >
                                {translateString("searchForDelivery", aplSettings.culture)}
                            </button>
                        </div>
                        <div className="input-group-append">
                            {counterState === 0 ? (
                                <button
                                    id="btn-delvery-print"
                                    className="btn btn-sm btn-primary"
                                    type="button"
                                    onClick={printMerckLabels}
                                    disabled={merckLabels.length === 0}
                                >
                                    {translateString("print", aplSettings.culture)} &nbsp;
                                </button>
                            ) : (
                                <button
                                    id="btn-delvery-print"
                                    className="btn btn-sm btn-danger"
                                    type="button"
                                    onClick={cancelPrinting}
                                    disabled={merckLabels.length === 0}
                                >
                                    {/* {counterRef.current} / {merckLabels.length} &nbsp; */}
                                    {counterState} / {merckLabels.length} &nbsp;
                                    <React.Fragment>
                                        <span id="btnRefreshSpinner" className="spinner-border spinner-border-sm" role="status"></span>
                                    </React.Fragment>
                                </button>
                            )}
                            {counterState === 0 && pdfFile !== "" && <DownloadButtonRaw pdfFile={pdfFile} />}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-6">{translateString("dropLocation", aplSettings.culture)}</div>
                <div className="col-6">
                    <select className="form-control" onChange={e => setDropLocationId(parseInt(e.target.value))} value={dropLocationId}>
                        {dropLocations.map((dropLocation, index) => {
                            return (
                                <option key={index} value={dropLocation.dropLocationId}>
                                    {dropLocation.dropRang}-{dropLocation.dropLocation}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>

            <div className="row">
                <div className="col-6">{translateString("printerName", aplSettings.culture)}</div>
                <div className="col-6">
                    <select
                        className="form-control"
                        onChange={e => setSelectedPrinterId(parseInt(e.target.value))}
                        value={selectedPrinterId}
                    >
                        {printers.map((printer, index) => {
                            return (
                                <option key={index} value={printer.printerId}>
                                    {printer.printerName}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
            <br />

            <DtGrid2 options={dtGridPropsMerck}></DtGrid2>
        </div>
    );
}
